var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C5.44772 12 5 12.4477 5 13C5 13.5523 5.44772 14 6 14H16.4352L19.926 18.2665C20.3058 18.7307 20.874 19 21.4739 19H23.5H24.2676C24.6134 19.5978 25.2597 20 26 20C27.1046 20 28 19.1046 28 18C28 16.8954 27.1046 16 26 16C25.2597 16 24.6134 16.4022 24.2676 17H21.4739L17.9831 12.7335C17.6033 12.2693 17.0351 12 16.4352 12H6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C5.44772 6 5 6.44772 5 7C5 7.55228 5.44772 8 6 8H24.2676C24.2857 8.03136 24.3047 8.06218 24.3244 8.09243L24.3416 8.11822C24.701 8.65022 25.3096 9 26 9C27.1046 9 28 8.10457 28 7C28 5.89543 27.1046 5 26 5C25.2597 5 24.6134 5.4022 24.2676 6H6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H14.5367L18.9492 27.06C19.3146 27.6448 19.9556 28 20.6452 28H24.2676C24.6134 28.5978 25.2597 29 26 29C27.1046 29 28 28.1046 28 27C28 25.8954 27.1046 25 26 25C25.2597 25 24.6134 25.4022 24.2676 26H20.6452L16.2327 18.94C15.8672 18.3552 15.2262 18 14.5367 18H6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.1450f3fa7aaa932e562ac92186627644.svg";
export { ForwardRef as ReactComponent };